export const resetLocalBasketBooks = (): void => {
  localStorage.setItem('basket', JSON.stringify([]))
}
